<script lang="ts">

</script>

<section id="global-footer">
    <div class="global-footer-area">
        <div class="global-footer__title">田中涼介「復活」応援プロジェクト実行委員</div>
        <div class="global-footer__content">
            <div class="global-footer__item">
                <div class="global-footer__item-left">理事長</div>
                <div class="global-footer__item-right">山田智史</div>
            </div>
            <div class="global-footer__item">
                <div class="global-footer__item-left">理事</div>
                <ul class="global-footer__item-right">
                    <li class="item">荒川栄</li><li class="item">山田志津子</li><li class="item">澤田一典</li>
                    <li class="item">田中啓介</li><li class="item">清水琢巳</li><li class="item">山内颯太朗</li>
                </ul>
            </div>
            <div class="global-footer__item">
                <div class="global-footer__item-left">主管</div><div class="global-footer__item-right">華舞翔新体操倶楽部</div>
            </div>
            <div class="global-footer__item">
                <div class="global-footer__item-left">協力</div>
                <ul class="global-footer__item-right">
                    <li class="item">椎名桂子</li>
                    <li class="item">清水綾子</li>
                    <li class="item">仁科尚子</li>
                    <li class="item">松本広美</li>
                    <li class="item">井藤亘</li>
                    <li class="item">舘山楓弥</li>
                    <div class="annotation">※記事、写真、映像提供、GoFundMe、etc</div>
                </ul>
            </div>
        </div>
        <div class="global-footer__bottom-message">本活動は、青森大学の中田吉光先生・斉藤剛大先生、青森山田高校の尾坂雄右先生・柴田翔平先生の賛同を得て活動しています。</div>
    </div>
</section>

<style>
    #global-footer {
        padding:          40px 0;
        background-color: #333333;
        color:            white;
    }

    .global-footer-area {
        width:  1024px;
        margin: 0 auto;
    }
    
    .global-footer__title {
        font-size:     20px;
        font-weight:   bold;
        margin-bottom: 16px;
    }

    .global-footer__content {
        width:            440px;
        margin:           0 auto 16px;
        padding:          16px 16px;
        background-color: white;
        color:            #333333;
        border-radius:    8px;
    }
    
    .global-footer__item {
        display:       block;
        margin-bottom: 16px;
        text-align:    left;
    }
    
    .global-footer__item:nth-child(4) {
        margin-bottom: 0;
    }

    .global-footer__item-left {
        display:        inline-block;
        width:          88px;
        font-weight:    bold;
        text-align:     left;
        vertical-align: top;
    }

    .global-footer__item-right {
        display:     inline-block;
        width:       300px;
        font-weight: bold;
        margin:      0;
        padding:     0;
        text-align:  left;
    }

    .global-footer__item-right .item {
        display:    inline-block;
        width:      100px;
        list-style: none;
    }

    .global-footer__item-right .annotation {
        display:     inline-block;
        font-size:   14px;
        font-weight: normal;
    }
</style>